const generalMarketingIpfdDependantConsents = [
  { consentName: 'MARKETING_EMAIL' },
  { consentName: 'MARKETING_IM' },
  { consentName: 'MARKETING_PAPER_MAIL' },
  { consentName: 'MARKETING_PHONE' },
  { consentName: 'MARKETING_PUSH' },
  { consentName: 'MARKETING_ROBO' },
  { consentName: 'MARKETING_SMS' },
];

const esState = [
  {
    consentName: 'MARKETING_IPFD',
    version: 'ES_ES_Creditea_BlendedMarketingIPFDAndChannels_20180207',
    dependantConsents: generalMarketingIpfdDependantConsents,
  },
  {
    consentName: 'MARKETING_3RD_PARTY',
    version: 'ES_ES_Creditea_marketing3rdParty_20180207',
  },
  {
    consentName: 'MARKETING_DATA_TRANSFER',
    version: 'ES_ES_Creditea_marketingDataTransfery_20180208',
  },
];

const fiState = [
  {
    consentName: 'MARKETING_IPFD',
    version: 'FI_FI_C24_BlendedMarketingIPFDAndChannels_20180125',
    dependantConsents: [
      { consentName: 'MARKETING_EMAIL' },
      { consentName: 'MARKETING_PAPER_MAIL' },
      { consentName: 'MARKETING_PHONE' },
      { consentName: 'MARKETING_PUSH' },
      { consentName: 'MARKETING_ROBO' },
      { consentName: 'MARKETING_SMS' },
    ],
    showFullText: true,
  },
  {
    consentName: 'MARKETING_3RD_PARTY',
    version: 'FI_FI_C24_marketing3rdParty_20180125',
    showFullText: true,
  },
];

if (!SELF_SERVICE) {
  fiState.push({
    consentName: 'ASIAKASTIETO_DATAPOOL',
    version: 'FI_FI_C24_DPDDatapool_20180725',
    showFullText: true,
  });
}

const eeState = [
  {
    consentName: 'MARKETING_IPFD',
    version: 'EE_EE_C24_BlendedMarketingIPFDAndChannels_20180126',
    localizedVersions: {
      ru: 'EE_RU_C24_BlendedMarketingIPFDAndChannels_20180126',
    },
    dependantConsents: generalMarketingIpfdDependantConsents,
  },
  {
    consentName: 'MARKETING_3RD_PARTY',
    version: 'EE_EE_C24_marketing3rdParty_20180126',
    localizedVersions: {
      ru: 'EE_RU_C24_marketing3rdParty_20180126',
    },
  },
];

const lvState = [
  {
    consentName: 'MARKETING_IPFD',
    version: 'LV_LV_C24_BlendedMarketingIPFDAndChannels_20180206',
    localizedVersions: {
      ru: 'LV_RU_C24_BlendedMarketingIPFDAndChannels_20180206',
    },
    dependantConsents: generalMarketingIpfdDependantConsents,
  },
  {
    consentName: 'MARKETING_3RD_PARTY',
    version: 'LV_LV_C24_marketing3rdParty_20180206',
    localizedVersions: {
      ru: 'LV_RU_C24_marketing3rdParty_20180206',
    },
  },
];

const plState = [
  {
    consentName: 'MARKETING_IPFD',
    version: 'PL_PL_HAPI_BlendedMarketingIPFDAndChannels_20180201',
    dependantConsents: [
      { consentName: 'MARKETING_IM' },
      { consentName: 'MARKETING_PAPER_MAIL' },
      { consentName: 'MARKETING_PUSH' },
    ],
  },
  {
    consentName: 'MARKETING_EMAIL',
    version: 'PL_PL_HAPI_BlendedMarketingEmailAndSMS_20180201',
    dependantConsents: [
      { consentName: 'MARKETING_SMS' },
    ],
  },
  {
    consentName: 'MARKETING_PHONE',
    version: 'PL_PL_HAPI_BlendedMarketingPhoneAndRobo_20180201',
    dependantConsents: [
      { consentName: 'MARKETING_ROBO' },
    ],
  },
  {
    consentName: 'MARKETING_DATA_TRANSFER',
    version: 'PL_PL_HAPI_marketingDataTransfer_20180201',
  },
];

const ltState = [
  {
    consentName: 'dataProcessingConsent',
    version: 'LT_LT_C24_BlendedMarketingIPFDAndChannels_20180201',
    showFullText: true,
  },
  {
    consentName: 'consent',
    version: 'LT_LT_C24_BlendedMarketingIPFDAndChannels_20180201',
    dependantConsents: generalMarketingIpfdDependantConsents,
    showFullText: true,
  },
  {
    consentName: 'idenfyConsent',
    version: 'LT_LT_C24_BlendedMarketingIPFDAndChannels_20180201',
    dependantConsents: generalMarketingIpfdDependantConsents,
    showFullText: true,
  },
];

const mxState = [
  {
    consentName: 'MARKETING_IPFD',
    version: 'MX_consent',
    dependantConsents: [
      { consentName: 'MARKETING_EMAIL' },
      { consentName: 'MARKETING_SMS' },
    ],
  },
  {
    consentName: 'MARKETING_3RD_PARTY',
    version: 'MX_consent',
  },
  {
    consentName: 'MARKETING_DATA_TRANSFER',
    version: 'MX_consent',
  },
  {
    consentName: 'MARKETING_IM',
    version: 'MX_consent',
  },
  {
    consentName: 'MARKETING_PAPER_MAIL',
    version: 'MX_consent',
  },
  {
    consentName: 'MARKETING_PUSH',
    version: 'MX_consent',
  },
  {
    consentName: 'MARKETING_PHONE',
    version: 'MX_consent',
  },
  {
    consentName: 'MARKETING_ROBO',
    version: 'MX_consent',
  },
];

const auState = [
  {
    consentName: 'MARKETING_DATA_TRANSFER',
    version: 'AU_consent',
  },
  {
    consentName: 'MARKETING_PHONE',
    version: 'AU_consent',
  },
  {
    consentName: 'MARKETING_PAPER_MAIL',
    version: 'AU_consent',
  },
  {
    consentName: 'MARKETING_IPFD',
    version: 'AU_consent',
  },
  {
    consentName: 'MARKETING_EMAIL',
    version: 'AU_consent',
  },
  {
    consentName: 'MARKETING_PUSH',
    version: 'AU_consent',
  },
  {
    consentName: 'MARKETING_3RD_PARTY',
    version: 'AU_consent',
  },
  {
    consentName: 'MARKETING_SMS',
    version: 'AU_consent',
  },
  {
    consentName: 'MARKETING_ROBO',
    version: 'AU_consent',
  },
  {
    consentName: 'MARKETING_IM',
    version: 'AU_consent',
  },
];

const czState = [
  {
    consentName: 'MARKETING_PHONE',
    version: 'CZ_Creditea_BlendedMarketingIPFDAndChannels_20180207',
  },
  {
    consentName: 'MARKETING_FROM_LEADS',
    version: 'CZ_Creditea_MarketingFromLeads_20180207',
  },
];

let marketingConsentsState;
switch (COUNTRY) {
  case 'ES':
    marketingConsentsState = esState;
    break;
  case 'EE':
    marketingConsentsState = eeState;
    break;
  case 'FI':
    marketingConsentsState = fiState;
    break;
  case 'LT':
    marketingConsentsState = ltState;
    break;
  case 'LV':
    marketingConsentsState = lvState;
    break;
  case 'PL':
    marketingConsentsState = plState;
    break;
  case 'MX':
    marketingConsentsState = mxState;
    break;
  case 'CZ':
    marketingConsentsState = czState;
    break;
  case 'AU':
    marketingConsentsState = auState;
    break;
  default:
    marketingConsentsState = [];
}

const initialMarketingConsentsState = marketingConsentsState;

export default initialMarketingConsentsState;
